import React from 'react';
import * as bie from "react-bootstrap";
import { Field, ErrorMessage } from "formik";
import { ImagePdfBucket } from "../../CommonUtils/ImagesBase64";
import { viewImage } from "../../CommonUtils/viewImage";
import { BsEyeFill } from "react-icons/bs";
import allowNumbersOnly from '../../CommonUtils/CommonValidations';
import { FcInfo } from "react-icons/fc";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { config } from '../../CommonUtils/CommonURLS';
import { CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import Swal from 'sweetalert2';
const clearFormikFields = (formik, fields = []) => {
    fields.forEach((field) => {
        formik.setFieldValue(field, "");
        formik.setFieldTouched(field, false);
    });
};

export const SchemeSelect = ({ phase }) => (
    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4}>
        <label className="mb-1">Scheme</label>
        <Field
            as="select"
            name="rusaPhase"
            className="form-control"
        >
            <option value="">--select--</option>
            {phase.map((p, i) => (
                <option key={i} value={p.rusa_phase}>
                    {p.rusa_phase}
                </option>
            ))}

        </Field>
        <ErrorMessage name="rusaPhase" component="div" className="text-danger" />
    </bie.Col >
);


export const WorkDetailsSelect = ({
    works,
    name = "constructionType",
    label = "Details of Work",
    onChange
}) => (
    <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
        <label className="mb-1">{label}</label>

        <Field
            as="select"
            name={name}
            className="form-control"
            {...(onChange ? { onChange } : {})}
        >
            <option value="">-- Select --</option>

            {works?.map((item) => (
                <option
                    key={item.sub_comp_id_works}
                    value={item.sub_comp_id_works}
                >
                    {item.sub_comp_name_works}
                </option>
            ))}
            <option value="99"> Others</option>

        </Field>

        <ErrorMessage name={name} component="div" className="text-danger" />
    </bie.Col>
);

export const OtherWorkInput = () => (
    <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
        <label className="mb-1">Other Work</label>
        <Field name="otherWork" className="form-control" />
        <ErrorMessage name="otherWork" component="div" className="text-danger" />
    </bie.Col>
);

export const NoOfUnitsInput = ({ label = "Number of Units / Nature of Work" }) => (
    <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
        <label className="mb-1">{label}</label>
        <Field name="noOfUnitsConstructed" className="form-control" onKeyPress={allowNumbersOnly} />
        <ErrorMessage name="noOfUnitsConstructed" component="div" className="text-danger" />
    </bie.Col>
);

// export const ProgressSelect = ({ name = "progressOfWork", label = "Status of Work" }) => (
//     <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
//         <label className="mb-1 d-block">{label}</label>
//         <Field as="select" name={name} className="form-control">
//             <option value="">-- Select --</option>
//             <option value="ongoing">Ongoing / Not Started</option>
//             <option value="completed">Completed</option>
//         </Field>
//         <ErrorMessage name={name} component="div" className="text-danger" />
//     </bie.Col>
// );

export const ProgressSelect = ({
    name = "progressOfWork",
    label = "Status of Work",
    formik,
    ongoingClearFields = [],
    completedClearFields = [],
}) => (
    <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
        <label className="mb-1 d-block">{label}</label>

        <Field
            as="select"
            name={name}
            className="form-control"
            onChange={(e) => {
                const value = e.target.value;
                formik.setFieldValue(name, value);

                if (value === "ongoing") {
                    clearFormikFields(formik, completedClearFields);
                }

                if (value === "completed") {
                    clearFormikFields(formik, ongoingClearFields);
                }

                if (!value) {
                    clearFormikFields(formik, [
                        ...ongoingClearFields,
                        ...completedClearFields,
                    ]);
                }
            }}
        >
            <option value="">-- Select --</option>
            <option value="ongoing">Ongoing / Not Started</option>
            <option value="completed">Completed</option>
        </Field>

        <ErrorMessage name={name} component="div" className="text-danger" />
    </bie.Col>
);


export const StartDateInput = ({ name = "startDate" }) => (
    <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
        <label className="mb-1">Start Date</label>
        <Field type="date" name={name} className="form-control" />
        <ErrorMessage name={name} component="div" className="text-danger" />
    </bie.Col>
);

export const EndDateInput = ({ name = "dateOfCompletion" }) => (
    <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
        <label className="mb-1"> Proposed Date of Completion </label>
        <Field type="date" name={name} className="form-control" />
        <ErrorMessage name={name} component="div" className="text-danger" />
    </bie.Col>
);

export const PercentageCompletionInput = () => (
    <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
        <label className="mb-1">Percentage of Completion</label>
        <Field name="percentageOfCompletion" className="form-control" maxLength={3} onKeyPress={allowNumbersOnly} />
        <ErrorMessage name="percentageOfCompletion" component="div" className="text-danger" />
    </bie.Col>
);

export const PresentStatusInput = () => (
    <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
        <label className="mb-1">Present Status</label>
        <Field name="presentStatus" className="form-control" />
        <ErrorMessage name="presentStatus" component="div" className="text-danger" />
    </bie.Col>
);

export const GeoTaggedPhotoInput = ({ name, label = "Geo-Tagged Photos", formik }) => {

    const hasImage =
        formik?.values?.[name] &&
        String(formik.values[name]).trim() !== "";
    return (
        <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
            <label className="mb-1">{label}</label>

            <input type="file" className="form-control form-control-md" name={name}
                accept="image/*" onChange={(e) => {
                    const filename = name;
                    const path = name;

                    ImagePdfBucket(e, formik, path, filename, filename, "image");
                }}
            />

            {hasImage && (
                <div className="mt-2 d-flex align-items-center gap-2">
                    <button
                        type="button"
                        className="btn btn-outline-primary btn-sm"
                        title="View Uploaded Image"
                        onClick={() => viewImage(formik.values[name])}
                    >
                        <BsEyeFill size={18} />
                    </button>
                    <span style={{ fontSize: "12px", color: "#555" }}>Uploaded</span>
                </div>
            )}
            <ErrorMessage name={name} component="div" className="text-danger" />
        </bie.Col>
    );
};

export const GeoTaggedPdf = ({ name, label = "Geo-Tagged Photos", formik }) => {

    const hasImage =
        formik?.values?.[name] &&
        String(formik.values[name]).trim() !== "";
    return (
        <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
            <label className="mb-1">{label}</label>

            <input type="file" className="form-control form-control-md" name={name}
                accept="application/pdf"
                onChange={(e) => {
                    const filename = name;
                    const path = name;

                    ImagePdfBucket(e, formik, path, filename, filename, "pdf");
                }}
            />

            {hasImage && (
                <div className="mt-2 d-flex align-items-center gap-2">
                    <button
                        type="button"
                        className="btn btn-outline-primary btn-sm"
                        title="View Uploaded Image"
                        onClick={() => viewImage(formik.values[name])}
                    >
                        <BsEyeFill size={18} />
                    </button>
                    <span style={{ fontSize: "12px", color: "#555" }}>view Pdf</span>
                </div>
            )}
            <ErrorMessage name={name} component="div" className="text-danger" />
        </bie.Col>
    );
};

export const FacilityInUseRadio = () => (
    <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
        <label className="mb-1 d-block">Whether Facility is in Use</label>
        <div className="form-check form-check-inline">
            <Field type="radio" name="wetherUsing" value="yes" className="form-check-input" id="facilityYes" />
            <label className="form-check-label" htmlFor="facilityYes">Yes</label>
        </div>
        <div className="form-check form-check-inline">
            <Field type="radio" name="wetherUsing" value="no" className="form-check-input" id="facilityNo" />
            <label className="form-check-label" htmlFor="facilityNo">No</label>
        </div>
        <ErrorMessage name="wetherUsing" component="div" className="text-danger" />
    </bie.Col>
);



export const VideoLinkInput = () => (
    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4}>
        <label className="mb-1">Video Link</label>
        <Field type="url" name="videoLinks" className="form-control" placeholder="https://youtube.com/..." />
        <ErrorMessage name="videoLinks" component="div" className="text-danger" />
    </bie.Col>
);
export const BriefDescriptionInput = () => {

    const tooltipText = `
Describe the area in Sq. Ft,
No. of floors, rooms, blocks,
Details of other facilities,
No. of beneficiaries etc.
`;

    return (
        <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4}>
            <label className="mb-1 d-flex align-items-center gap-1">
                Brief Description of Work

                <OverlayTrigger
                    placement="right"
                    overlay={<Tooltip>{tooltipText}</Tooltip>}
                >
                    <span style={{ cursor: "pointer" }}>
                        <FcInfo size={22} />
                    </span>
                </OverlayTrigger>
            </label>

            <Field as="textarea" name="briefDesc" className="form-control" />
            <ErrorMessage name="briefDesc" component="div" className="text-danger" />
        </bie.Col>
    );
};

// CompNameCell.js
export const CompNameCell = ({ row }) => {
    const { comp_name, otherwork } = row.original;
    return (
        <div style={{ whiteSpace: "normal" }}>
            {comp_name && comp_name.trim() !== "" ? comp_name : otherwork}
        </div>
    );
};



export const deleteWithConfirm = async ({ sno, apiPath, onSuccess }) => {
    console.log("deleteWithConfirm called");
    console.log("SNO received:", sno);
    console.log("API PATH:", apiPath);

    const result = await Swal.fire({
        title: "Are you sure?",
        text: "Do you want to delete this record?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
    });

    console.log("Swal result:", result);

    if (!result.isConfirmed) return;

    const url = `${config.url.API_URL}${apiPath}?sno=${sno}`;
    console.log("FINAL DELETE URL:", url);

    const res = await CommonAxiosPost(url);
    console.log("DELETE RESPONSE:", res);

    if (res?.data?.scode === "01") {
        Swal.fire(res.data.sdesc, "", "success");
        onSuccess?.();
    } else {
        Swal.fire("Delete failed", "", "error");
    }
};


